<div class="dx-card wide-card">
    <h4 class="content-block ap-green">TGEE Chemicals and Other</h4>

    <dx-data-grid class="fixGridHeight" id="tgeeProspectsChemicalsOtherDataGrid" [dataSource]="tgeeProspectsChemicalsOtherData"
        [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [allowColumnResizing]="true"
        [rowAlternationEnabled]="true">
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-export [enabled]="false"></dxo-export>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button text="Reset" stylingMode="contained" type="default" (onClick)="resetFilters()">
                </dx-button>
                <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                    (onClick)="exportExcel($event)">
                </dx-button>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
            [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>

        <dxi-column dataField="entryType" [width]="80"></dxi-column>
        <dxi-column dataField="siteId" [visible]="false" caption="Site Id" [width]="120"></dxi-column>
        <dxi-column dataField="productionFacilityId" caption="Facility Id " [width]="120"></dxi-column>
        <dxi-column dataField="continents" [width]="120"></dxi-column>
        <dxi-column dataField="tgeeRegions" caption="TGEERegions" [width]="120"></dxi-column>
        <dxi-column dataField="lasuRegions" caption="LASURegions" [width]="120"></dxi-column>
        <dxi-column dataField="hycoRegions" caption="HYCORegions" [width]="120"></dxi-column>
        <dxi-column dataField="corporateRegions" caption="Corporate Regions" [width]="120"></dxi-column>
        <dxi-column dataField="tgeeStrategyRegions" caption="TGEEStrategy Regions" [width]="120"></dxi-column>
        <dxi-column dataField="tgeeStrategyRegionsShort" caption="TGEEStrategy Regions Short" [width]="120"></dxi-column>
        <dxi-column dataField="commercialProductRegions" caption="Commercial Product Regions" [width]="120"></dxi-column>
        <dxi-column dataField="sAndOPRegions" caption="S And OP Regions" [width]="120"></dxi-column>
        <dxi-column dataField="chinavsROW" caption="China vs ROW" [width]="80"></dxi-column>
        <dxi-column dataField="country" [width]="100"></dxi-column>
        <dxi-column dataField="countryShort" [width]="100"></dxi-column>
        <dxi-column dataField="stateProvince" [width]="100"></dxi-column>
        <dxi-column dataField="city" [width]="100"></dxi-column>
        <dxi-column dataField="unitOwner" [width]="170"></dxi-column>    
        <dxi-column dataField="unitOwnerDetails" [width]="170"></dxi-column>
        <dxi-column dataField="tgeeStrategySegments" caption="TGEEStrategy Segments" [width]="150"></dxi-column>
        <dxi-column dataField="segmentShort" [width]="100"></dxi-column>
        <dxi-column dataField="processLong" [width]="100"></dxi-column>
        <dxi-column dataField="processShort" [width]="100"></dxi-column>
        <dxi-column dataField="application" [width]="100"></dxi-column>
        <dxi-column dataField="gasificationvsNonGasification" caption="Gasification vs Non Gasification" [width]="140"></dxi-column>
        <dxi-column dataField="metalsvsNonMetals" [width]="100"></dxi-column>
        <dxi-column dataField="oxygenNitrogenHyCOIndustryApplication" caption="Business Category: Industry" [width]="100"></dxi-column>
        <dxi-column dataField="oxygenNitrogenHyCOIndustrySegmentApplication" caption="Business Category: Segment" [width]="100"></dxi-column>
        <dxi-column dataField="applicationInvolvesGasificationUsingOxygenPlusSolidOrLiquidFuel" caption="Business Category: Involves Gasification Using Oxygen Plus Solid/Liquid Fuel" [width]="150"></dxi-column>
        <dxi-column dataField="activity" [width]="150"></dxi-column>
        <dxi-column dataField="process" [width]="170"></dxi-column>
        <dxi-column dataField="feedstock" [width]="100"></dxi-column>
        <dxi-column dataField="status" [width]="100"></dxi-column>
        <dxi-column dataField="operationalStatus" [width]="120"></dxi-column>
        <dxi-column dataField="probability" [width]="90"></dxi-column>
        <dxi-column dataField="systemEstimatedGaseousOxygen" caption="System Estimated Gaseous Oxygen (tonne/ tonne of product)" [width]="150"></dxi-column>
        <dxi-column dataField="systemEstimatedOxygenDemandSupply" [width]="150"></dxi-column>
        <dxi-column dataField="gaseousOxygen" caption="Gaseous Oxygen (mtpd)" [width]="100"></dxi-column>
        <dxi-column dataField="oxygenDemandSupply" [width]="130"></dxi-column>
        <dxi-column dataField="oxygenProspect" [width]="100"></dxi-column>

        <dxi-column dataField="systemEstimatedGaseousNitrogen" caption="System Estimated Gaseous Nitrogen (tonne/ tonne of product)" [width]="150"></dxi-column>
        <dxi-column dataField="systemEstimatedNitrogenDemandSupply" [width]="150"></dxi-column>
        <dxi-column dataField="gaseousNitrogen" caption="Gaseous Nitrogen (mtpd)" [width]="100"></dxi-column>
        <dxi-column dataField="nitrogenDemandSupply" [width]="130"></dxi-column>
        <dxi-column dataField="nitrogenProspect" [width]="100"></dxi-column>

        <dxi-column dataField="systemEstimatedGaseousHydrogen" caption="System Estimated Gaseous Hydrogen (kNm3 / tonne of product)" [width]="150"></dxi-column>
        <dxi-column dataField="systemEstimatedHydrogenDemandSupply" [width]="150"></dxi-column>
        <dxi-column dataField="GaseousHydrogen" caption="Gaseous Hydrogen (kNm3/h)" [width]="100"></dxi-column>
        <dxi-column dataField="hydrogenDemandSupply" [width]="130"></dxi-column>
        <dxi-column dataField="hydrogenProspect" [width]="100"></dxi-column>

        <dxi-column dataField="systemEstimatedGaseousCarbonMonoxide" caption="System Estimated Gaseous Carbon Monoxide (kNm3/ tonne of product)" [width]="150"></dxi-column>
        <dxi-column dataField="systemEstimatedCarbonMonoxideDemandSupply" [width]="150"></dxi-column>
        <dxi-column dataField="gaseousCarbonMonoxide" caption="Gaseous Carbon Monoxide (kNm3/h)" [width]="100"></dxi-column>
        <dxi-column dataField="carbonMonoxideDemandSupply" [width]="130"></dxi-column>
        <dxi-column dataField="carbonMonoxideProspect" [width]="100"></dxi-column>

        <dxi-column dataField="systemEstimatedGaseousSyngas" caption="System Estimated Gaseous Syngas (kNm3/ tonne of product)" [width]="150"></dxi-column>
        <dxi-column dataField="systemEstimatedSyngasDemandSupply" [width]="150"></dxi-column>
        <dxi-column dataField="gaseousSyngas" caption="Gaseous Syngas (kNm3/h)" [width]="100"></dxi-column>
        <dxi-column dataField="syngasDemandSupply" [width]="130"></dxi-column>
        <dxi-column dataField="syngasProspect" [width]="100"></dxi-column>
        <dxi-column dataField="awardMonth" width="100"></dxi-column>
        <dxi-column dataField="awardYear" width="100"></dxi-column>
        <dxi-column dataField="calendarAwardTiming" width="150"></dxi-column>
        <dxi-column dataField="fiscalAwardTiming" width="100"></dxi-column>
        <dxi-column dataField="onstreamMonth" width="100"></dxi-column>
        <dxi-column dataField="onstreamYear" width="100"></dxi-column>
        <dxi-column dataField="businessModel" width="100"></dxi-column>
        <dxi-column dataField="supplyMode" width="100"></dxi-column>
        <dxi-column dataField="notes" caption="Notes" [width]="400"></dxi-column>
        <dxi-column dataField="infoSource" width="220"></dxi-column>
        <dxi-column dataField="latitude" width="100"></dxi-column>
        <dxi-column dataField="longitude" width="100"></dxi-column>
        <dxi-column dataField="altitude" width="100"></dxi-column>
    </dx-data-grid>

    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>